export const GET_FIXEDINFO = "GET_FIXEDINFO";
export const GET_FIXEDINFO_UPDATE = "GET_FIXEDINFO_UPDATE";
